import { AdminTermsModal } from '@dealstack/frontend/shared/components/TermsModals/AdminTermsModal';
import { InvestorTermsModal } from '@dealstack/frontend/shared/components/TermsModals/InvestorTermsModal';
import { PrivacyPolicyModal } from '@dealstack/frontend/shared/components/TermsModals/PrivacyPolicyModal';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { useTranslationAuth } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Flex } from '@mantine/core';
import { memo, useState } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	isInvestorApp?: boolean;
}

const TermsAndPolicy = ({ className, isInvestorApp }: Props) => {
	const tAuth = useTranslationAuth();

	const [isPrivacyModalOpened, setIsPrivacyModalOpened] = useState(false);
	const [isTermsModalOpened, setIsTermsModalOpened] = useState(false);

	const TermsModal = isInvestorApp ? InvestorTermsModal : AdminTermsModal;

	return (
		<Flex justify="center" gap="2em" className={className}>
			<Text colorFaded bold variant="p-sm" isLink onClick={() => setIsTermsModalOpened(true)}>
				{tAuth('footer.user_terms')}
			</Text>
			<Text
				colorFaded
				bold
				variant="p-sm"
				isLink
				onClick={() => setIsPrivacyModalOpened(true)}
			>
				{tAuth('footer.privacy_policy')}
			</Text>

			{isPrivacyModalOpened && (
				<PrivacyPolicyModal onClose={() => setIsPrivacyModalOpened(false)} />
			)}
			{isTermsModalOpened && <TermsModal onClose={() => setIsTermsModalOpened(false)} />}
		</Flex>
	);
};

const Memoized = memo(TermsAndPolicy);
const _TermsAndPolicyExport = styled(Memoized)``;

export { _TermsAndPolicyExport as TermsAndPolicy };
